module.exports = __webpack_public_path__ + "static/media/PR.7477154a.svg";